import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RequireGameAuth from '../../shared/components/RequireGameAuth';
import Layout from '../../shared/components/Layout';
import Sidebar from '../../shared/components/Sidebar';
import HomePage from './pages/HomePage';
import GameLevelsPage from './pages/GameLevelsPage';
import LeaderboardPage from './pages/LeaderboardPage';
import UsersPage from './pages/UsersPage';
import DailyChallengePage from './pages/DailyChallengePage';
import { auth } from './firebase';
import navItems from './nav';
import './theme.css';

const ZipApp = () => (
  <div className="game-zip">
    <RequireGameAuth auth={auth} title="Zip Game Admin">
      {(user) => (
        <Layout
          title="Admin Panel"
          renderSidebar={({ isOpen, closeSidebar }) => (
            <Sidebar
              auth={auth}
              brandLabel="Admin Menu"
              navItems={navItems}
              isOpen={isOpen}
              closeSidebar={closeSidebar}
              userEmail={user?.email}
            />
          )}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/levels" element={<GameLevelsPage />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/daily" element={<DailyChallengePage />} />
          </Routes>
        </Layout>
      )}
    </RequireGameAuth>
  </div>
);

export default ZipApp;
